import {
  gspx,
  trackAmplitudeEvent,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Data Map';

const MAP_LAYERS_EVENT_NAMES = {
  TOGGLE_GROUP_CHECKBOX: 'map_toggle_group_checkbox',
  VIEW: 'map_layers_control_view',
};

/**
 * Tracks when the Map Layers control becomes available on the map.
 * @param {Object} params
 * @param {'tabs' | 'flat'} params.layout - Tabbed UI vs legacy flat list
 */
export const trackMapLayersControlView = ({ layout }) => {
  trackAmplitudeEvent(MAP_LAYERS_EVENT_NAMES.VIEW, {
    route: 'Map',
    layout,
  });
};

export const toggleGroupCheckboxTracking = (
  isAnyLayerChecked,
  name,
  irpVersion,
) => {
  // layer.isChecked is in previous state here before reset
  // if is on, turn off layer
  // if is off, turn on layer
  const onOffText = isAnyLayerChecked ? 'off' : 'on';

  gspx.trackEvent({
    name: MAP_LAYERS_EVENT_NAMES.TOGGLE_GROUP_CHECKBOX,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Turn ${onOffText} ${name}`,
      Category: 'Spatial Layer',
      'Launched date': new Date(),
      irpVersion,
      name,
    },
  });
};
